import trainDeviationStore from './store'

export default class TrainDeviationModule {
  name = 'trainDeviation'
  constructor({ store }) {
    store.registerModule(this.name, trainDeviationStore)
  }
}
